/**
 * Pure H OS · Phase D Wave 4 · Warehouses (types + live view).
 * MongoDB collection: `pureh_warehouses`.
 */
import { liveArray } from "../services/store";

export type WarehouseKind = "raw" | "finished" | "ecommerce" | "retail";

export type Warehouse = {
  id: string;
  code: string;
  name: string;
  location: string;
  kind: WarehouseKind;
  skuCount: number;
  utilizationPct: number;
  valueEGP: number;
  manager: string;
};

export const WAREHOUSES: Warehouse[] = liveArray<Warehouse>("warehouses");
